import React from 'react'

interface VimeoEmbedProps {
  vimeoId: string
  hash: string
  title: string
}

const VimeoEmbed: React.FC<VimeoEmbedProps> = ({ vimeoId, hash, title }) => {
  if (!vimeoId || !hash) {
    return (
      <div
        style={{
          width: '100%', // 부모 컨테이너 전체 너비 사용
          aspectRatio: '16/9', // 16:9 비율로 높이 자동 계산
          position: 'relative',
          backgroundColor: '#f5f5f5',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          border: '2px dashed #ccc',
          borderRadius: '8px',
          minHeight: '300px', // 최소 높이 보장
        }}
      >
        <div
          style={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            textAlign: 'center',
            color: '#666',
          }}
        >
          <p>Vimeo ID와 Hash Key를 입력하면</p>
          <p>동영상 미리보기가 표시됩니다</p>
        </div>
      </div>
    )
  }

  const embedUrl = `https://player.vimeo.com/video/${vimeoId}?h=${hash}&badge=0&autopause=0&player_id=0&app_id=58479`

  return (
    <div
      style={{
        width: '100%', // 부모 컨테이너 전체 너비 사용
        aspectRatio: '16/9', // 16:9 비율로 높이 자동 계산
        position: 'relative',
      }}
    >
      <iframe
        src={embedUrl}
        style={{
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
        }}
        frameBorder="0"
        allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media"
        allowFullScreen
        title={title || '동영상 미리보기'}
      />
    </div>
  )
}

export default VimeoEmbed
